(function () {
  var catalogByHandle = {};
  var themeSettings = window.__SABUNAL_THEME_SETTINGS__ || {};
  var catalogSyncEnabled = themeSettings.catalogSyncEnabled !== false;
  var currentPath = (window.location.pathname || '/').replace(/\/+$/, '') || '/';
  var productMatch = currentPath.match(/^\/products\/([^/]+)$/);
  var needsFullCatalog = currentPath === '/'
    || currentPath === '/magaza'
    || currentPath === '/urun-arama'
    || currentPath.indexOf('/kategori/') === 0;

  var catalogUrl = !catalogSyncEnabled
    ? null
    : productMatch
    ? '/products/' + encodeURIComponent(decodeURIComponent(productMatch[1])) + '.js'
    : needsFullCatalog
      ? '/products.json?limit=250'
      : null;

  function toNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function imageSource(image) {
    return image && (image.src || image.url || image);
  }

  function normalizeVariant(variant, pricesAreInCents) {
    var label = variant.title && variant.title !== 'Default Title'
      ? variant.title
      : variant.option1 || 'Tek seçenek';
    var price = toNumber(variant.price);
    var compareAtPrice = toNumber(variant.compare_at_price);

    if (pricesAreInCents) {
      price /= 100;
      compareAtPrice /= 100;
    }

    return {
      label: label,
      price: price,
      sku: variant.sku || '',
      barcode: variant.barcode || '',
      stock: variant.available === false ? 0 : 1,
      available: variant.available !== false,
      trackInventory: true,
      taxable: variant.taxable !== false,
      compareAtPrice: compareAtPrice,
      shopifyVariantId: variant.id
    };
  }

  function publishProductLinkCatalog() {
    window.__SABUNAL_PRODUCT_LINK_CATALOG__ = Object.keys(catalogByHandle)
      .map(function (handle) {
        return {
          handle: handle,
          title: catalogByHandle[handle] && catalogByHandle[handle].title
        };
      })
      .filter(function (product) { return product.handle && product.title; });
  }

  var catalogReady = catalogUrl
    ? fetch(catalogUrl, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Shopify catalog request failed.');
          return response.json();
        })
        .then(function (payload) {
          if (productMatch) {
            if (payload.handle) catalogByHandle[payload.handle] = payload;
            return;
          }

          (payload.products || []).forEach(function (product) {
            if (product.handle) catalogByHandle[product.handle] = product;
          });
          publishProductLinkCatalog();
        })
        .catch(function () {
          // The embedded catalog remains the safe fallback if Shopify is unavailable.
        })
    : Promise.resolve();

  window.__SABUNAL_CATALOG_READY__ = catalogReady;
  window.__SABUNAL_BUILD_CATALOG__ = function (embeddedCatalog) {
    if (!Object.keys(catalogByHandle).length) return embeddedCatalog;

    return embeddedCatalog.map(function (embeddedProduct) {
      var handle = embeddedProduct.shopifyHandle || embeddedProduct.slug;
      var remoteProduct = catalogByHandle[handle];
      if (!remoteProduct) return embeddedProduct;

      var images = (remoteProduct.images || [])
        .map(imageSource)
        .filter(Boolean);
      var variants = (remoteProduct.variants || []).map(function (variant) {
        return normalizeVariant(variant, Boolean(productMatch));
      });
      var variantImages = {};

      (remoteProduct.variants || []).forEach(function (variant) {
        var label = variant.title && variant.title !== 'Default Title'
          ? variant.title
          : variant.option1 || 'Tek seçenek';
        var image = imageSource(variant.featured_image);
        if (image) variantImages[label] = image;
      });

      return Object.assign({}, embeddedProduct, {
        name: remoteProduct.title || embeddedProduct.name,
        variants: variants.length ? variants : embeddedProduct.variants,
        images: images.length ? images : embeddedProduct.images,
        image: images[0] || embeddedProduct.image,
        variantImages: Object.keys(variantImages).length
          ? variantImages
          : embeddedProduct.variantImages
      });
    });
  };
})();
